module.exports = __webpack_public_path__ + "img/guaranteeIcon1.085b122a.png";